import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/settings/pages.tsx', () => import('./pages'))

/** /settings: ungated, as in the portal (only its cards are gated). */
export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    handle: { crumb: () => 'Settings' } satisfies CrumbHandle,
    lazy: page('SettingsPage')
  }
]
